import styled from 'styled-components';

import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

export const $AmountCell = styled.div`
  text-align: right;
  white-space: nowrap;
`;

export const $AmountHeaderCel = styled.div`
  text-align: right;
  min-width: ${spacing(28)};
`;
